import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, TableRow, TableCell, Typography } from "@material-ui/core";
import CustomSwitch from "../../../../Common/CustomSwitch";

const styles = makeStyles({
    tableCell: {
        border: 0,
        padding: 3,
    }
});

const ReportRow = props => {
    const { name, displayName, private: own, default: standard, onPrivateChange, onDefaultChange, alignCenter } = props;
    const classes = styles();

    return (
        <TableRow>
            <TableCell className={classes.tableCell}>
                <Typography variant="body1">
                    {displayName}:
                </Typography>
            </TableCell>
            <TableCell className={classes.tableCell} align={alignCenter && "center"}>
                <CustomSwitch
                    color="primary"
                    checked={own}
                    onChange={() => onPrivateChange(name)}
                />
            </TableCell>
            <TableCell className={classes.tableCell} align={alignCenter && "center"}>
                <CustomSwitch
                    color="primary"
                    checked={standard}
                    onChange={() => onDefaultChange(name)}
                />
            </TableCell>
        </TableRow>
    );
};

ReportRow.propTypes = {
    name: PropTypes.string,
    displayName: PropTypes.string,
    private: PropTypes.bool,
    default: PropTypes.bool,
    onPrivateChange: PropTypes.func,
    onDefaultChange: PropTypes.func,
    alignCenter: PropTypes.bool
};

export default ReportRow;
